import { mutate as swrMutate } from 'swr'

export const mutate = (url: string) =>
  swrMutate((key) => {
    if (typeof key === 'string') {
      return key?.startsWith(url)
    }

    return Array.isArray(key) && key?.some((k) => k.startsWith?.(url))
  })
